import React, { useEffect, useState } from 'react';
import './tooltip.css';
import { store } from '../../../app/store';
import { postAPI, API_URL } from '../../../app/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { hasPermission, isAdmin } from '../../../store/hooks/Permission';

export default function List({ PopupID = '', setIsEdit, setEditId }) {
  const store_data = JSON.parse(store());
  const [books, setBooks] = useState([]);

  const [canView, setCanView] = useState(false);
  const [canEdit, setCanEdit] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  const fetchBooks = async () => {
    const response = await postAPI('/books/list', { org_id: store_data?.org_id, user: store_data });

    if (response?.status === 1) {
      setBooks(response?.data || []);
    } else {
      setBooks([]);
    }
  };

  useEffect(() => {
    const checkPermissions = async () => {
      if (isAdmin()) {
        setCanView(true);
        setCanEdit(true);
        setCanDelete(true);
        fetchBooks();
      } else {
        const viewAllowed = await hasPermission('BOOKS', 'Books', 'VIEW');
        const editAllowed = await hasPermission('BOOKS', 'Books', 'EDIT');
        const deleteAllowed = await hasPermission('BOOKS', 'Books', 'DELETE');

        setCanView(viewAllowed);
        setCanEdit(editAllowed);
        setCanDelete(deleteAllowed);

        if (viewAllowed) {
          fetchBooks();
        }
      }
    };

    checkPermissions();
  }, []);

  const handleRemove = async (id) => {
    if (!canDelete) {
      toast.error('You do not have permission to perform this action');
      return;
    }

    const response = await postAPI('/books/remove', { org_id: store_data?.org_id, id, user: store_data });

    if (response?.status === 1) {
      toast.success('Book removed successfully.');
      window.location.reload();
    } else {
      toast.error(response?.error || 'Sorry! Something went wrong.');
    }
  };

  return (
    <>
      <ToastContainer />
      <table className="table card-table">
        <thead>
          <tr>
            <th style={{ width: '80px' }}>Image</th>
            <th>Book Name</th>
            <th>Author</th>
            <th>Publisher</th>
            <th>Price</th>
            <th>Purchase Link</th>
            <th>Details</th>
            <th style={{ width: '140px' }}>Actions</th>
          </tr>
        </thead>
        <tbody className="table-border-bottom-0">
          {!canView ? (
            <tr>
              <td colSpan="8" className="text-center text-danger py-4">
                You do not have permission to view this page.
              </td>
            </tr>
          ) : books.length > 0 ? (
            books.map((val, index) => (
              <tr key={val?.id || index}>
                <td>
                  {val?.book_image ? (
                    <img
                      src={`${API_URL}/${val.book_image}`}
                      alt={val?.book_name || 'Book'}
                      style={{ width: '48px', height: '48px', objectFit: 'cover', borderRadius: '6px' }}
                    />
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td>{val?.book_name || '-'}</td>
                <td>{val?.author_name || '-'}</td>
                <td>{val?.publisher_name || '-'}</td>
                <td>{val?.price ?? '-'}</td>
                <td>
                  {val?.purchase_link ? (
                    <a href={val.purchase_link} target="_blank" rel="noreferrer">Open</a>
                  ) : '-'}
                </td>
                <td style={{ maxWidth: '240px', whiteSpace: 'pre-wrap' }}>{val?.details || '-'}</td>
                <td>
                  {canEdit && (
                    <span
                      className="badge bg-label-primary me-1 custom-tooltip"
                      data-bs-toggle="modal"
                      data-bs-target={`#${PopupID}`}
                      onClick={() => {
                        setIsEdit(true);
                        setEditId(val?.id);
                      }}
                    >
                      <i className="fa fa-pen"></i>
                      <span className="tooltip-text">Edit Book</span>
                    </span>
                  )}

                  {canDelete && (
                    <span
                      className="badge bg-label-danger me-1 cursor-pointer custom-tooltip"
                      onClick={() => {
                        if (window.confirm('Are you sure? This action will permanently remove this data!')) {
                          handleRemove(val?.id);
                        }
                      }}
                    >
                      <i className="fa fa-trash"></i>
                      <span className="tooltip-text">Delete Book</span>
                    </span>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center py-4">No books found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
}
